import React from "react";
import debounce from "../common/debounce";

const Button = ({ show, className, disabled, submit, children }) => {
  return (
    <div>
      {show ? (
        <button
          type="button"
          className={className + " disabled"}
          disabled={disabled || false}
        >
          Loading...
        </button>
      ) : (
        <button
          type="button"
          onClick={debounce(submit, 2000)}
          className={className}
          disabled={disabled || false}
        >
          {children}
        </button>
      )}
    </div>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/parts/Button.jsx